"use client"
import React, {useCallback} from 'react'
import {DotButton, useDotButton} from './Dot'
import {
    PrevButton,
    NextButton,
    usePrevNextButtons
} from './Arrow'
import Autoplay from 'embla-carousel-autoplay'
import useCarousel from 'embla-carousel-react'
import '../../../assets/styles/scss/_carousel.scss'
import Image from "next/dist/client/legacy/image";
import {DynamicIcon} from "../../DynamicIcon";
import ReactMarkdown from "react-markdown";
import ValuePropIntro from "../ValuePropIntro";


const EmblaCarousel = (props) => {
    const {messages: slides, options} = props
    const [emblaRef, emblaApi] = useCarousel(options, [Autoplay()])

    const onNavButtonClick = useCallback((emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }, [])

    const {selectedIndex, scrollSnaps, onDotButtonClick} = useDotButton(
        emblaApi,
        onNavButtonClick
    )

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi, onNavButtonClick)

    return (
        <div>
            <ValuePropIntro {...props}/>
            <div className="row">
                <section className="embla">
                    <div className="embla__viewport" ref={emblaRef}>
                        <div className="embla__container">
                            {slides?.map((itm, index) => (
                                <div className="embla__slide" key={index}>
                                    <div className="embla__slide__number card ">
                                        <img className="carouselImg" src={itm?.image?.url} alt={"gallery" + index}/>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="embla__controls">
                        {/* Carousel Arrow */}
                        {/*<div className="embla__buttons">*/}
                        {/*    <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />*/}
                        {/*    <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />*/}
                        {/*</div>*/}

                        <div className="embla__dots">
                            {scrollSnaps.map((_, index) => (
                                <DotButton
                                    key={index}
                                    onClick={() => onDotButtonClick(index)}
                                    className={'embla__dot'.concat(
                                        index === selectedIndex ? ' embla__dot--selected' : ''
                                    )}
                                />
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default EmblaCarousel
